import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Layouts
import { HomeComponent } from './home/home.component';

import { LoginComponent } from './login/login.component';
// DemandPortal
import { DPCustomerComponent } from './portalv1/dp-customer.component';
import { DPCustomerCreateComponent } from './portalv1/dp-customer-create.component';
import { DPCustomerDetailComponent } from './portalv1/dp-customer-detail.component';
import { DPAccountComponent } from './portalv1/dp-accounts-component';
import { DPAccountCreateComponent } from './portalv1/dp-account-create.component';
import { DPAccountDetailComponent } from './portalv1/dp-account-detail.component';
import { DPUsersComponent } from './portalv1/dp-users.component';
import { DPUserCreateComponent } from './portalv1/dp-user-create.component';
import { DPUserDetailComponent } from './portalv1/dp-user-detail.component';
import { DPSubscriptionsComponent } from './portalv1/dp-subscriptions.component';
import { DPModuleCreateComponent } from './portalv1/dp-module-create.component';
import { DPModuleDetailComponent } from './portalv1/dp-module-detail.component';
import { DPProjectComponent } from './portalv1/dp-project.component';
import { DPProjectCreateComponent } from './portalv1/dp-project-create.component';
import { DPProjectDetailComponent } from './portalv1/dp-project-detail.component';
import { DPTimeSheetCreateComponent } from './portalv1/dp-timesheet-create.component';
import { DPTimeSheetDetailComponent } from './portalv1/dp-timesheet-detail.component';
import { AllProjectComponent } from './portalv1/all-project.component';
import { CustomerHubComponent } from './portalv1/components/customer-hub/customer-hub.component';
// //V2
// import {DPV2CustomerComponent} from './portalv2/dp-customer.component'
// import {DPV2CustomerCreateComponent} from './portalv2/dp-customer-create.component'
// import {DPV2CustomerDetailComponent} from './portalv2/dp-customer-detail.component'
// import {DPV2AccountComponent} from './portalv2/dp-accounts-component'
// import {DPV2AccountCreateComponent} from './portalv2/dp-account-create.component'
// import {DPV2AccountDetailComponent} from './portalv2/dp-account-detail.component'
// import {DPV2UsersComponent} from './portalv2/dp-users.component'
// import {DPV2UserCreateComponent} from './portalv2/dp-user-create.component'
// import {DPV2UserDetailComponent} from './portalv2/dp-user-detail.component'
// import {DPV2SubscriptionsComponent} from './portalv2/dp-subscriptions.component'
// Parrots
import { InternalUserComponent } from './user/internaluser.component';
import { UserCreateComponent } from './user/user-create.component';
import { UserDetailComponent } from './user/user-detail.component';
// TMS
import { TmsLandingpageComponent } from './tms/tms-landingpage.component';
import { TitleCreateComponent } from './tms/title-create.component';
import { DataAnamolyComponent } from './catalogue/dataanamoly/dataanamoly.component';
import { DipDetectionComponent } from './catalogue/dipdetection/dipdetection.component';
import { DataAnamolyComponent1 } from './catalogue/dataanamoly/dataanamoly.component.1';

import { DashboardComponent } from './dashboard/dashboard.component';
import { GlobalTrendsComponent } from './globaltrends/globaltrends.component';
import { DataHealthComponent } from './catalogue/datahealth/datahealth.component';
import { CatalogApiComponent } from './catalogue/catalog-api/catalog-api.component';
import { DipDetectionComponent1 } from './catalogue/dipdetection/dipdetection.component.1';
import { InfohashComponent } from './catalogue/infohash/infohash.component';
import { SearchTitlesComponent } from './catalogue/search-titles/search-titles.component';
import { StatisticsComponent } from './statistics/statistics.component';
import { DiscoveryComponent } from './catalogue/discovery/discovery.component';
import {GlobalSearchTitlesComponent} from './global-search/global-search-titles.component';
import {VideoTitlesComponent} from './youtube-video/video-search/video-titles.component';
import {AuthGuard} from './guard/auth.guard';
import {BulkInfohashV2TitlesComponent} from './bulkinfohash-v2/bulk-infohash-v2-search/bulk-infohash-v2-titles.component';
import {ESDashboardComponent} from './elastic-search-dashboard/esDashboard.component';
import {VerificationSearchTitlesComponent} from './catalog-verification/search-titles/verification-search-titles.component';
import {BusinessOperationsSearchTitlesComponent} from './business-operations/business-operations-search-titles.component';
import {JustwatchIdFetchSearchTitlesComponent} from './justwatch-id-fetch/justwatch-id-fetch-search-titles.component';


export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginComponent, data: { title: 'Login' } },
    { path: 'dip', component: DipDetectionComponent1, data: { title: 'Dip' } },
    { path: 'wiki', component: DataAnamolyComponent1, data: { title: 'Wiki' } },
    {
        path: '', component: HomeComponent, data: { title: 'Home' }, children: [
            { path: 'catalog', component: CatalogApiComponent, data: { title: 'Catalog API' }, canActivate: [AuthGuard] },
            { path: 'search', component: SearchTitlesComponent, data: { title: 'Search Titles' }, canActivate: [AuthGuard] },
            { path: 'catalog-verification', component: VerificationSearchTitlesComponent, data: { title: 'Catalog Verification' }, canActivate: [AuthGuard] },
            { path: 'datahealth', component: DataHealthComponent, data: { title: 'Data Health' } , canActivate: [AuthGuard] },
            { path: 'dataanamoly', component: DataAnamolyComponent, data: { title: 'Data Anamoly' } , canActivate: [AuthGuard] },
            { path: 'dipdetection', component: DipDetectionComponent, data: { title: 'Dip Detection' } , canActivate: [AuthGuard] },
            { path: 'globaltrends', component: GlobalTrendsComponent, data: { title: 'Global Trends' } , canActivate: [AuthGuard] },
            { path: 'dashboard', component: DashboardComponent, data: { title: 'Dashboard' } , canActivate: [AuthGuard] },
            { path: 'projects', component: AllProjectComponent, data: { title: 'Consulting Projects' } , canActivate: [AuthGuard] },
            { path: 'infohash', component: InfohashComponent, data: { title: 'Infohash' } , canActivate: [AuthGuard] },
            { path: 'bulkinfohash', component: BulkInfohashV2TitlesComponent, data: { title: 'Bulk Infohash' } , canActivate: [AuthGuard] },
            { path: 'youtubevideo', component: VideoTitlesComponent, data: { title: 'Youtube Video Classification' } , canActivate: [AuthGuard] },
            { path: 'esdashboard', component: ESDashboardComponent, data: { title: 'ES Dashboards' } , canActivate: [AuthGuard] },
            { path: 'stats', component: StatisticsComponent, data: { title: 'Statistics' } , canActivate: [AuthGuard] },
            { path: 'discovery', component: DiscoveryComponent, data: { title: 'Discovery' } , canActivate: [AuthGuard] },
            { path: 'globalsearch', component: GlobalSearchTitlesComponent, data: { title: 'Global Search' } , canActivate: [AuthGuard] },
            { path: 'businessoperations', component: BusinessOperationsSearchTitlesComponent, data: { title: 'Business Operations' } , canActivate: [AuthGuard] },
            { path: 'external-id', component: JustwatchIdFetchSearchTitlesComponent, data: { title: 'Business Operations' } , canActivate: [AuthGuard] },

            {
                path: 'parrot', data: { title: 'Parrot' },
                children: [
                    { path: '', component: InternalUserComponent, data: { title: 'Parrot' } },
                    { path: 'create', component: UserCreateComponent, data: { title: 'Create Parrot' } },
                    { path: ':userId', component: UserDetailComponent, data: { title: 'Parrot Details' } }
                ]
            },
            {
                path: 'tms', data: { title: 'Title Management' }, children: [
                    {
                        path: 'titles', component: TmsLandingpageComponent, data: { title: 'View Titles' }
                    },
                    {
                        path: 'createTitle', component: TitleCreateComponent, data: { title: 'Create Title' }
                    },
                    {
                        path: 'titleDetails/:content_id',
                        component: TitleCreateComponent,
                        data: { title: 'Title details' }
                    }
                ]
            },
            // v1
            { path: 'demandportal', redirectTo: 'demandportal/customer', pathMatch: 'full' },
            {
                path: 'demandportal', data: { title: 'Demand Portal' },
                children: [
                    { path: 'customer', component: DPCustomerComponent, data: { title: 'Customer' } },
                    {
                        path: 'customer', data: { title: 'Customer' }, children: [
                            {
                                path: 'customercreate',
                                component: DPCustomerCreateComponent,
                                data: { title: 'Create Customer' }
                            },
                            {
                                path: 'customerdetail/:customer_id',
                                component: DPCustomerDetailComponent,
                                data: { title: 'Customer Detail' }
                            },
                            {
                                path: 'account/:customerId',
                                component: DPAccountComponent,
                                data: {
                                    title: 'Account'
                                }
                            },
                            {
                                path: 'account',
                                data: {
                                    title: 'Account'
                                },
                                children: [

                                    {
                                        path: 'accountcreate/:customerId',
                                        component: DPAccountCreateComponent,
                                        data: {
                                            title: 'Create Account V1'
                                        }
                                    }
                                    ,
                                    {
                                        path: 'accountdetail/:account_id',
                                        component: DPAccountDetailComponent,
                                        data: {
                                            title: 'Account Detail'
                                        }
                                    },
                                    {
                                        path: 'users/:account_id',
                                        component: DPUsersComponent,
                                        data: {
                                            title: 'Demand Portal User'
                                        }
                                    },
                                    {
                                        path: 'subscriptions/:account_id',
                                        component: DPSubscriptionsComponent,
                                        data: {
                                            title: 'Subscriptions'
                                        }
                                    },
                                    {
                                        path: 'projects/:account_id',
                                        component: DPProjectComponent,
                                        data: {
                                            title: 'Projects'
                                        }
                                    },

                                    {
                                        path: 'subscriptions',
                                        data: {
                                            title: 'Subscriptions'
                                        }, children: [

                                            {
                                                path: 'modulecreate/:account_id',
                                                component: DPModuleCreateComponent,
                                                data: {
                                                    title: 'Module Create'
                                                }
                                            },
                                            {
                                                path: 'moduledetail/:accountId/:subscriptionId',
                                                component: DPModuleDetailComponent,
                                                data: {
                                                    title: 'Module Detail'
                                                }
                                            }

                                        ]
                                    },
                                    {
                                        path: 'users',
                                        data: {
                                            title: 'Users'
                                        },
                                        children: [
                                            {
                                                path: 'userdetail/:userId',
                                                component: DPUserDetailComponent,
                                                data: {
                                                    title: 'Demand Portal User Detail'
                                                }
                                            },
                                            {
                                                path: 'usercreate/:account_id',
                                                component: DPUserCreateComponent,
                                                data: {
                                                    title: 'Create Demand Portal User'
                                                }
                                            },
                                        ]
                                    },
                                    {
                                        path: 'projects',
                                        data: {
                                            title: 'Projects'
                                        },
                                        children: [
                                            {
                                                path: 'projectcreate/:account_id',
                                                component: DPProjectCreateComponent,
                                                data: {
                                                    title: 'Create Project'
                                                }
                                            }, {
                                                path: 'projectdetail/:project_id',
                                                component: DPProjectDetailComponent,
                                                data: {
                                                    title: 'Project Detail'
                                                }
                                            },
                                            {
                                                path: 'timesheetcreate/:project_id',
                                                component: DPTimeSheetCreateComponent,
                                                data: {
                                                    title: 'Time Sheet Create'
                                                }
                                            },
                                            {
                                                path: 'timesheetdetail/:timesheet_id',
                                                component: DPTimeSheetDetailComponent,
                                                data: {
                                                    title: 'Time Sheet Detail'
                                                }
                                            }
                                        ]
                                    },

                                ]
                            },
                        ]
                    },
                    { path: 'customer-hub', component: CustomerHubComponent, data: { title: 'Customer Hub' } },
                ]
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts